import React from "react";
import { Typography } from "@mui/material";

const LabelText = ({ text, style, ...props }: any) => {
  return (
    <Typography
      variant="body1"
      style={{ marginBottom: "1rem", marginTop: "1.5rem", ...style }}
      {...props}
    >
      {text}
    </Typography>
  );
};

export default LabelText;
